import { useEffect, useState } from "react";

import { useSelector } from "../../store";
import { fetchFirestoreDocument } from "../../utility/firebase";

type AdminDoc = { isChatAdmin: boolean; eventIds?: string[] };

/**
 * to ban, set `isChatAdmin` to True in `/admins/<userId>` document
 * allow firestore permission warning when comment has deleted or user is not admin
 */
export const useIsChatAdmin = (eventId: string | undefined) => {
  const userId = useSelector((state) => state.auth.user.uid);

  const [isChatAdmin, setIsChatAdmin] = useState<boolean>(false);
  useEffect(() => {
    // テストの場合は無視
    if (!eventId || process.env.NODE_ENV === "test") {
      return;
    }

    void fetchFirestoreDocument<AdminDoc>(`/admins/${userId}`).then((doc) => {
      if (!eventId || !doc) return;
      setIsChatAdmin(
        doc.isChatAdmin &&
          (doc.eventIds == null || doc.eventIds.includes(eventId))
      );
    });
  }, [eventId, userId]);

  return isChatAdmin;
};
